import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Page} from '../domain/page.model';
import {environment} from '../../../environments/environment';
import {HttpUtils} from '../utils/http-utils';
import { Deals } from '../domain/pmp-deals.model';


@Injectable({
  providedIn: 'root'
})
export class PmpDealsService {

  constructor(private httpClient: HttpClient) {
  }

  public getDealsList(filter: any): Observable<Page<Deals>> {
    return this.httpClient.get<Page<Deals>>(`${environment.serviceUrl}/api/deal`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  public getDealsStatuses(filter: any): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/deal/statuses`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  public getDealByID(id: string): Observable<Deals> {
    return this.httpClient.get<Deals>(`${environment.serviceUrl}/api/deal/${id}`);
  }

  public createDeal(data: Deals): Observable<Deals> {
    return this.httpClient.post<Deals>(`${environment.serviceUrl}/api/deal`, data);
  }

  public updateDeal(data: Deals): Observable<Deals> {
    return this.httpClient.put<Deals>(`${environment.serviceUrl}/api/deal/${data.id}`, data);
  }
}
